module.exports = __webpack_public_path__ + "static/img/celoscope-detail-34.d790d27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-34.jpg
// module id = oiH4
// module chunks = 51